// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__RFcEc","colCheckbox":"styles_colCheckbox__2yxSG"};